module.exports = function() {
	throw new Error("define cannot be used indirect");
};



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/amd-define.js
// module id = ../../../../usr/local/share/.config/yarn/global/node_modules/webpack/buildin/amd-define.js
// module chunks = 44